module.exports = __webpack_public_path__ + "static/media/vijesti.4bf4b23a.svg";